export const path = "/master-design-ionvo";
export const component = () => import("./index.jsx");
export const sidebar = {
  title: "MASTER DESIGN",
  section: "IONVO",
  group: null,
  order: 2,
  roles: [
    "Authenticated",
    "roundler-admin",
    "aluna",
    "aluna-management",
    "hop-management",
    "design",
    "design-roundler",
    "aluna-afiliado",
  ],
};
